import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MainTitle from 'base/components/MainTitle/index';
import FieldWrapper from 'base/components/forms/FieldWrapper';
import Title3 from 'base/components/Title3/index';
import { deleteMailingList } from 'documents/store/mailinglists/actions';
import { getActiveMailingList } from 'documents/store/mailinglists/selectors';
import { closeModal } from 'modal/store/actions';
import Button from 'base/components/Button/index';
import Col from 'base/components/Col/index';
import Row from 'base/components/Row/index';

const CreateFolderModal = ({
  name, closeModal, mailingList, deleteMailingList,
}) => (
  <>
    <MainTitle withSpaceBelow>Delete mailing list</MainTitle>

    <FieldWrapper>
        Do you really want to delete
      <Title3>{mailingList && mailingList.name}</Title3>
    </FieldWrapper>

    <Row>
      <Col>
        <Button isFullWidth variant="secondary" onClick={() => closeModal(name)}>No, cancel</Button>
      </Col>
      <Col>
        <Button
          isFullWidth
          variant="primary"
          onClick={() => { closeModal(name); deleteMailingList(mailingList); }}
        >
            Yes, delete
        </Button>
      </Col>
    </Row>
  </>
);
CreateFolderModal.propTypes = {
  name: PropTypes.string.isRequired,
  mailingList: PropTypes.object.isRequired, // eslint-disable-line
  closeModal: PropTypes.func.isRequired,
  deleteMailingList: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  mailingList: getActiveMailingList(state),
});

const mapDispatchToProps = {
  deleteMailingList,
  closeModal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateFolderModal);
